
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const Check = () => (
      <>
        <polyline points="20 6 9 17 4 12"></polyline>
      </>
    );
    export default Check;
    